
export const DealerCountries = {
    usa: 1,
    canada: 2,
    unitedKingdom: 3,
    france: 4
};
